module.exports = __webpack_public_path__ + "img/icon-visa-small.eb4c36aa.svg";